import { ServiceWorkOrderPlanningItemFieldsDto } from '../service-work-order/service-work-order-planning-item-fields';
import { PlanningCardFieldDescriptor } from '../planning-card-field';

/**
 * Card fields for the ServiceWorkOrderStep card, in display order. The header (customer/work-order
 * number/status, plus the always-on "Step X" tag) is listed first as `fixed` — always shown, locked in
 * the config panel. `schedule` and `kind` are synthetic keys gating the computed schedule line and the
 * kind badge.
 */
export const SERVICE_WORK_ORDER_STEP_CARD_FIELDS: PlanningCardFieldDescriptor[] = [
  { key: 'customer', labelKey: 'Doc::Planning:CardField:Customer', fixed: true },
  { key: 'number', labelKey: 'Doc::Planning:CardField:Number', fixed: true },
  { key: 'status', labelKey: 'Doc::Planning:CardField:Status', fixed: true },
  { key: 'stepName', labelKey: 'Doc::ProductionFolderLine:Step' },
  { key: 'equipment', labelKey: 'Product::Equipment:Equipment' },
  { key: 'worker', labelKey: 'Contact::Worker' },
  { key: 'article', labelKey: 'Doc::Article' },
  { key: 'articleCode', labelKey: 'Doc::Planning:CardField:ArticleCode' },
  { key: 'articleSerial', labelKey: 'Doc::StockDoc:ArticleSerial' },
  { key: 'responsible', labelKey: '::Responsible' },
  { key: 'schedule', labelKey: 'Doc::Planning:CardField:Schedule' },
  { key: 'kind', labelKey: 'Doc::Planning:CardField:Kind' },
];

/**
 * Typed view of a ServiceWorkOrderStep item's `PlanningItemDto.displayFields` payload. Mirrors the
 * backend `ServiceWorkOrderStepPlanningItemFieldsDto` record (Digiwall.GoliathDocuments.Planning) — keep
 * the two in sync. The planned entity is a `WorkOrderStepLine`, so it carries the same parent-document
 * fields as the base ServiceWorkOrder source (inherited) plus the step-line specifics below.
 * `displayFields` is transported as a loosely-typed object, so the card casts it to this interface.
 */
export interface ServiceWorkOrderStepPlanningItemFieldsDto
  extends ServiceWorkOrderPlanningItemFieldsDto {
  /** Owning ServiceWorkOrderDoc id — the deep-link target (the item id is the step-line id). */
  serviceWorkOrderId?: string;
  /** Step order within its document — shown as a "Step X" tag so steps can be planned in sequence. */
  reference?: number;
  stepName?: string;
  equipment?: string;
  worker?: string;

  // Filter fields — ids used by the client-side board filter predicate (not shown on the card).
  equipmentId?: string;
  workerId?: string;
}
